<template lang="pug">
	.web-services--script-builder--array-operations.flex-col.space
		.operation.flex-col(v-for="({ operation, stored }, opIdx) in resultOperations")
			.flex-row.justify.tb-padding-small.header
				.flex-row.space.align-center
					.clickable.hoverable(@click="$set(stored, 'disabled', !stored.disabled)")
						fas(:icon="stored.disabled ? 'far fa-square' : 'square-check'")
					b.upper {{operation.name}}
					.clickable.hoverable.preview(@click="setPreviewingOperation(opIdx, stored)", :title="$tCaption('Preview')", :class="{ 'active': previewingOperation === stored }")
						fas(:icon="previewingOperation === stored ? 'eye' : 'far fa-eye'")
					fas.clickable.hoverable(@click="$set(stored, 'collapsed', !stored.collapsed)", :icon="stored.collapsed ? 'chevron-right' : 'chevron-down'")
				.flex-row.space-small
					.add-button.flex-row.align-center.center.clickable.hoverable(@click="editOperationCriteria(stored, operation)", :title="$tCaption('Condition of operation applying')", :class="{ active: stored.condition && stored.condition.active }")
						fas(icon="filter", size="2xs")
					.add-button.flex-row.align-center.center.clickable.hoverable(v-if="opIdx > 0", @click="moveArrayItem(operations, opIdx, -1)")
						fas(icon="caret-up", size="2xs")
					.add-button.flex-row.align-center.center.clickable.hoverable(v-if="opIdx < resultOperations.length - 1", @click="moveArrayItem(operations, opIdx, 1)")
						fas(icon="caret-down", size="2xs")
					.add-button.flex-row.align-center.center.clickable.hoverable(@click="operations.splice(opIdx, 1)")
						fas(icon="close", size="2xs")
			.flex-col.space(v-if="!stored.collapsed")
				.flex-col(v-for="prop in operation.props", v-if="(!prop.hidden || !prop.hidden(stored, prop, operation)) && (!['field', 'fields'].includes(prop.type) || !hideFieldSelection)")
					.flex-row.space.align-center(v-if="prop.title || prop.hint")
						.font-small.grey.tb-padding-small(v-if="prop.title") {{prop.title}}
						fas.hoverable(v-if="prop.hint", icon="circle-info" size="xs", :title="prop.hint")
					DxNumberBox(v-if="prop.type === 'number'", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", stylingMode="filled")
					DxCheckBox(v-if="prop.type === 'bool'", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", :text="prop.text")
					DxTagBox.compact(v-if="prop.type === 'fields' && fields && fields.length", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", 
						stylingMode="filled", :data-source="getFields(prop, opIdx)", valueExpr="name", displayExpr="name", :multiline="false", :maxDisplayedTags="2", :height="40",)
					DxTextBox(v-if="prop.type === 'string'", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", stylingMode="filled")
					.flex-row.space(v-if="prop.type === 'formula'")
						DxTextBox.flex-1(:value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", stylingMode="filled")
						DxDropDownButton(:data-source="getFields(prop, opIdx)", displayExpr="name", valueExpr="name", @itemClick="e => onFormulaItemClick(stored, prop, e)", :showArrowIcon="false", text="+",
							:dropDownOptions="dropDownOptions", stylingMode="text")
					DxSelectBox(v-if="prop.type === 'list'", :data-source="prop.list", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", stylingMode="filled")
					DxSelectBox(v-if="prop.type === 'field'", :data-source="getFields(prop, opIdx)", :value="getStoredValue(stored, prop.id)", @value-changed="e => setStoredValue(stored, prop.id, e.value)", 
						stylingMode="filled", valueExpr="name", displayExpr="name", showClearButton="true")
					.tb-padding-small(v-if="prop.type === 'criteria'")
						DxButton(icon="edit", :text="$tCaption('Edit criteria')", @click="editCriteria(stored, prop, opIdx)")
					.flex-col.space(v-if="prop.type === 'mapping'")
						.mapping-value.flex-row.space.align-center(v-for="(mappingItem, mpIdx) in getStoredValue(stored, prop.id)")
							.flex-row.space.align-center
								.flex-col
									.font-small.grey {{$tCaption('Key')}}
									.flex-row.space.align-center
										.add-button.flex-row.align-center.center.clickable.hoverable(@click="editMappingItemCriteria(mappingItem, opIdx)", :title="$tCaption('Edit criteria')", :class="{ active: mappingItem.criteria }")
											fas(icon="filter", size="2xs")
										DxTextBox(:value.sync="mappingItem.key", stylingMode="filled", width="50")
							.flex-col.flex-1
								.font-small.grey {{$tCaption('Value')}}
								.flex-row.align-center.space.flex-1
									DxTextBox.flex-1(:value.sync="mappingItem.value", stylingMode="filled")
									.add-button.flex-row.align-center.center.clickable.hoverable(v-if="mpIdx > 0", @click="moveArrayItem(getStoredValue(stored, prop.id), mpIdx, -1)")
										fas(icon="caret-up", size="2xs")
									.add-button.flex-row.align-center.center.clickable.hoverable(v-if="mpIdx < getStoredValue(stored, prop.id).length - 1", @click="moveArrayItem(getStoredValue(stored, prop.id), mpIdx, 1)")
										fas(icon="caret-down", size="2xs")
									.add-button.flex-row.align-center.center.clickable.hoverable(@click="$confirm(void 0, $tCaption('Remove mapping?')).then(() => getStoredValue(stored, prop.id).splice(mpIdx, 1))")
										fas(icon="times", size="2xs")
						.flex-row.center
							.add-button.flex-row.align-center.center.clickable.hoverable.space(@click="getStoredValue(stored, prop.id).push({ key: null, value: null, criteria: null })")
								span {{$tCaption('Add mapping value')}}
								fas(icon="plus", size="2xs")
		.flex-row
			.add-button.flex-row.align-center.center.clickable.hoverable(@click="initAddArrayOperation")
				fas(icon="plus", size="2xs")
		Popup(v-if="arrayOperationsPopupVisible", :popupVisible.sync="arrayOperationsPopupVisible", :width="320", :autosize="true")
			.flex-col.space.web-services--script-builder.web-services--script-builder--array-operations
				.array-operation.flex-col.clickable.hoverable(v-for="operation in arrayOperations.filter(f => !hideConvertToValue || hideConvertToValue && !f.convertsToValue)", @click="confirmAddArrayOperation(operation)")
					.flex-row.justify.align-center
						.upper {{operation.name}}
						fas(icon="plus")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="arrayOperationsPopupVisible = false")
		Popup(v-if="filterOperationPopupVisible", :popupVisible.sync="filterOperationPopupVisible", :width="640", :autosize="true", :title="$tCaption('Edit criteria')")
			.flex-col.space.web-services--script-builder.web-services--script-builder--array-operations
				FilterBuilder(v-if="editingProp", :fields="editingPropColumns", v-model="editingProp.value")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="filterOperationPopupVisible = false")
		Popup(v-if="operationCriteriaPopupVisible", :popupVisible.sync="operationCriteriaPopupVisible", :width="640", :autosize="true", :title="$tCaption('Edit operation condition')")
			.flex-col.space.web-services--script-builder.web-services--script-builder--array-operations
				.flex-col(v-for="param in serviceParams")
					BaseParameterSelector(:parameter="param", :paramValues="editingProp.condition.paramValues", :paramCaptions="editingProp.condition.paramCaptions", @change="calculateConditionActivity", :fullStructure="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="operationCriteriaPopupVisible = false")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Clear', '@actions')", @click="clearOperationCriteria")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import JsonViewer from 'json-viewer';
import DxCheckBox from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxTagBox from 'devextreme-vue/tag-box';
import Popup from 'app-core/Popup.vue';
import DxNumberBox from 'devextreme-vue/number-box';
import FilterBuilder from 'app-core/FilterBuilder.vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import BaseParameterSelector from './BaseParameterSelector.vue';

export default {
	translationCategory: 'webServiceCaller.ScriptBuilder',
	components: { DxButton, JsonViewer, DxCheckBox, DxSelectBox, DxTextBox, Popup, DxNumberBox, DxTagBox, FilterBuilder, DxDropDownButton, BaseParameterSelector },
	props: ['operations', 'hideConvertToValue', 'fields', 'valueType', 'service', 'hideFieldSelection'],
	data() {
		return {
			arrayOperations: [
				{ name: 'skip', props: [{ id: 'count', type: 'number', value: 0 }] },
				{ name: 'take', props: [{ id: 'count', type: 'number', value: 1 }] },
				{ name: 'sort', props: [
					{ id: 'fields', type: 'fields', value: [], title: this.$tCaption('Fields') }, 
					{ id: 'desc', type: 'bool', value: false, text: this.$tCaption('Sort descending') }
				]},
				{ name: 'group', props: [
					{ id: 'groups', type: 'fields', title: this.$tCaption('Groups'), value: [], filterFields: (v) => v?.dataType !== 'object' }, 
					{ id: 'aggregates', type: 'fields', title: this.$tCaption('Summaries'), value: [], filterFields: (v) => v?.dataType !== 'object' }, 
					{ id: 'aggregationType', title: this.$tCaption('Aggregation type'), type: 'list', list: ['sum', 'min', 'max', 'avg', 'count'], value: 'sum' } 
				] },
				{ name: 'filter', props: [{ id: 'criteria', type: 'criteria', value: null }] },
				{ name: 'aggregate', convertsToValue: true, props: [
					{ id: 'field', type: 'field', value: null, filterFields: (v) => v?.dataType !== 'object', hidden: () => !this.fields?.length, title: this.$tCaption('Result field') }, 
					{ id: 'operation', type: 'list', list: ['sum', 'min', 'max', 'avg', 'count'], value: 'sum' }
				]},
				{ name: 'unique', props: [
					{ id: 'field', type: 'field', value: null, filterFields: (v) => v?.dataType !== 'object', hidden: () => !this.fields?.length, title: this.$tCaption('Result field') }, 
				]},
				{ name: 'join', convertsToValue: true, props: [
					{ id: 'field', type: 'field', value: null, filterFields: (v) => v?.dataType !== 'object', hidden: () => !this.fields?.length, title: this.$tCaption('Result field') }, 
					{ id: 'delimeter', title: this.$tCaption('Delimeter'), type: 'string', value: ', ' },
				]},
				{ name: 'first', convertsToValue: true },
				{ name: 'last', convertsToValue: true },
				{ name: 'combine', props: [
					{ 
						id: 'formula',
						type: 'formula', value: '', title: this.$tCaption('Combination result'), 
						hint: this.$tCaption('Can be used columns in square brackets, for example: [ColumnName]. Also JS functions and coding supported.'),
						filterFields: (v) => v?.dataType !== 'object'
					},
					{ id: 'isCode', text: this.$tCaption('Is formula'), type: 'bool', value: false },
					{ id: 'fieldName', type: 'string', value: 'CombinedFieldName', title: this.$tCaption('Result field name'), hint: this.$tCaption('Use existing column name to replace value or new one for additional column.') }, 
				]},
				{ name: 'mapping', props: [
					{ 
						id: 'field',
						type: 'field', value: '', title: this.$tCaption('Mapping field'),
						hidden: () => !this.fields?.length
					},
					{ id: 'values', type: 'mapping', value: [], hidden: (stored) => !stored.props['field']?.value && this.fields?.length }, 
					{ id: 'default', type: 'string', value: null, title: this.$tCaption('Default value'), hidden: (stored) => !stored.props['field']?.value && this.fields?.length }, 
				]},
				{ name: 'format', props: [
					{ 
						id: 'field',
						type: 'field', value: '', title: this.$tCaption('Field'),
						hidden: () => !this.fields?.length
					},
					{ id: 'dataType', title: this.$tCaption('Data type'), type: 'list', list: ['date', 'number'], value: 'number', hidden: (stored) => !stored.props['field']?.value && this.fields?.length },
					{ id: 'format', title: this.$tCaption('Format'), type: 'string', value: '', hidden: (stored) => !(stored.props['field']?.value || !this.fields?.length) || stored.props['dataType']?.value != 'date' },
					{ id: 'utc', text: this.$tCaption('UTC'), type: 'bool', value: false, hidden: (stored) => !stored.props['field']?.value || stored.props['dataType']?.value != 'date' },
					{ id: 'roundTo', title: this.$tCaption('Round to'), type: 'number', value: 2, hidden: (stored) => !stored.props['field']?.value || stored.props['dataType']?.value != 'number' },
					{ id: 'delimeter', title: this.$tCaption('Delimeter'), type: 'string', value: ' ', hidden: (stored) => !stored.props['field']?.value || stored.props['dataType']?.value != 'number' },
				]},
			],
			arrayOperationsPopupVisible: false,
			filterOperationPopupVisible: false,
			operationCriteriaPopupVisible: false,
			editingProp: null,
			editingPropColumns: [],
			dropDownOptions: {
				minWidth: '200px'
			},
			paramValues: null,
			paramCaptions: null,
			previewingOperation: null
		};
	},
	computed: {
		resultOperations() {
			return this.operations.map(f => ({
				stored: f,
				operation: this.arrayOperations.find(c => c.name === f.name)
			})).filter(f => f.stored)
		},
		serviceParams() {
			return (this.service?.JsonDefinition?.Parameters || []).filter(f => f.UserEditable || f.ComplexParameterId);
		}
	},
	mounted() {
		if (__DEBUG__)
			window.scriptBuilderArrayOperations = this;
			
		this.prepareOperations();
	},
	methods: {
		setPreviewingOperation(opIdx, stored) {
			if (this.previewingOperation === stored) {
				this.previewingOperation = null;
				this.$emit('preview', null)
			} else {
				this.previewingOperation = stored;
				this.$emit('preview', stored)
			}
		},
		clearOperationCriteria() {
			this.$set(this.editingProp, 'condition', null);
			this.operationCriteriaPopupVisible = false;
		},
		calculateConditionActivity(values, captions) {
			this.$set(this.editingProp.condition, 'paramValues', values);
			this.$set(this.editingProp.condition, 'paramCaptions', captions);
			this.editingProp.condition.active = Object.keys(this.editingProp.condition.paramValues).some(f => !!this.editingProp.condition.paramValues[f]);
		},
		editOperationCriteria(stored) {
			if (__DEBUG__)
				window.scriptBuilderArrayOperations = this;

			this.editingProp = stored;
			if (!stored.condition) {
				this.$set(stored, 'condition', {
					paramValues: {},
					paramCaptions: {},
					active: false
				});
			}
			this.operationCriteriaPopupVisible = false;
			this.$nextTick(() => this.operationCriteriaPopupVisible = true);
		},
		editMappingItemCriteria(mappingItem, opIdx) {
			let mpObj = {};
			Object.defineProperty(mpObj, 'value', {
				get: () => mappingItem.criteria,
				set: (v) => mappingItem.criteria = v,
				enumerable: true
			});

			this.editingProp = mpObj;

			this.editingPropColumns = this.getFields(void 0, opIdx).filter(f => !['object', 'array'].includes(f.dataType)).map(f => ({
				dataField: f.name,
				dataType: f.dataType
			}));
			
			if (!this.editingPropColumns.length) {
				this.editingPropColumns.push({ dataField: this.$tCaption('ArrayValue'), dataType: this.valueType });
				mappingItem.isArrayCondition = true;
			} else if (mappingItem.isArrayCondition) {
				mappingItem.isArrayCondition = false;
			}

			this.filterOperationPopupVisible = false;
			this.$nextTick(() => this.filterOperationPopupVisible = true);
		},
		getStoredValue(stored, propId) {
			return stored.props[propId]?.value;
		},
		setStoredValue(stored, propId, v) {
			if (!stored.props.hasOwnProperty(propId)) {
				this.$set(stored.props, propId, { value: null });
			}
			stored.props[propId].value = v;
		},
		onFormulaItemClick(stored, prop, e) {
			if (__DEBUG__)
				console.debug('On formula item click', { e });
			
			let exVal = this.getStoredValue(stored, prop.id);
			this.setStoredValue(stored, prop.id, `${exVal ? `${exVal} ` : ''}[${e.itemData.name}]`);
		},
		prepareOperations() {
			(this.operations || []).map(f => {
				let op = this.arrayOperations.find(a => a.name === f.name);
				if (op) {
					_.defaultsDeep(f, op);
				}
			});
		},
		editCriteria(stored, prop, opIdx) {
			if (__DEBUG__)
				console.debug('editCriteria', { stored, prop });

			if (!stored.props.hasOwnProperty(prop.id)) {
				this.$set(stored.props, prop.id, { value: null });
			}

			this.editingProp = stored.props[prop.id];
			this.editingPropColumns = this.getFields(void 0, opIdx).filter(f => !['object', 'array'].includes(f.dataType)).map(f => ({
				dataField: f.name,
				dataType: f.dataType
			}));

			if (__DEBUG__)
				window.scriptBuilderArrayOperations = this;

			this.filterOperationPopupVisible = false;
			this.$nextTick(() => this.filterOperationPopupVisible = true);
		},
		moveArrayItem(arr, idx, direction) {
			var item = arr[idx];
			arr.splice(idx, 1);
			arr.splice(idx + direction, 0, item);
		},
		initAddArrayOperation() {
			this.arrayOperationsPopupVisible = false;
			setImmediate(() => this.arrayOperationsPopupVisible = true);
		},
		confirmAddArrayOperation(operation) {
			if (__DEBUG__)
				window.scriptBuilderArrayOperations = this;

			this.arrayOperationsPopupVisible = false;
			this.operations.push(({
				disabled: false,
				name: operation.name,
				props: _.cloneDeep(operation.props?.length && operation.props.reduce((res, prop) => { res[prop.id] = { value: prop?.value }; return res; }, {}) || {})
			}));
		},
		getFields(operationProp, opIdx) {
			let lastGroup = this.resultOperations.filter((f, fIdx) => fIdx < opIdx && f.operation.name === 'group' && !f.stored.disabled).slice(-1)[0];
			let lastGroupIdx = -1;

			if (lastGroup) {
				lastGroupIdx = this.resultOperations.findIndex(f => f === lastGroup);
			}

			let operationFields = this.resultOperations.filter((f, fIdx) => fIdx < opIdx
				&& (lastGroupIdx === -1 || fIdx > lastGroupIdx) 
				&& ['combine'].includes(f.operation.name)).filter(f => f.stored?.props['fieldName']?.value).map(f => ({ dataType: 'string', name: f.stored?.props['fieldName']?.value }));
			
			if (lastGroup) {
				let stored = lastGroup.stored;
				let groupsFields = (stored.props?.groups?.value || []).map(f => ({ dataType: (this.fields.find(df => df.name === f)?.dataType || 'string'), name: f }));
				let aggFields = (stored.props?.aggregates?.value || []).map(f => ({ dataType: (this.fields.find(df => df.name === f)?.dataType || 'number'), name: f }));

				if (__DEBUG__)
					console.debug('Get fields', { groupsFields, aggFields, lastGroup });

				return [
					...groupsFields,
					...aggFields,
					...operationFields
				]
			}
			
			return [
				...(!operationProp?.filterFields ? this.fields : this.fields.filter(operationProp.filterFields)),
				...operationFields
			];
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.web-services--script-builder--array-operations {
		.array-operation {
			margin: 1px;
			background: #efefef;
			border-radius: 4px;
			padding: 8px;
		}

		.preview {
			color: rgba(0,0,0,0.1);

			&.active {
				color: $base-accent;
			}
		}

		.operation {
			.header {
				border-bottom: 1px solid #f1f1f1;
			}
		}
	}
</style>
